import { GroupModal } from "./GroupModal";

export default GroupModal;import { GroupModal } from "./GroupModal";

export default GroupModal;